import { StatusFila, StatusTarefa, TipoFila, TipoTarefa } from '../enum';
import { TagGi } from '../tag-gi';

export class FilaTarefa {
  id?: number;
  idFila?: number;
  idFilaFuncionario?: number;
  nomeFilaFuncionario: string;
  status?: StatusTarefa;
  dtStatus?: Date;
  statusDescricao?: string;
  tipo?: TipoTarefa;
  idCupom?: string;
  idCupomVendedor?: string;
  temPrioridade?: boolean;
  dtAtribuicao?: Date;
  nomeFuncionario?: string;
  tags: TagGi[];
  buscouTags: boolean;
  dtCriacao?: Date;
  tipoSolicitante: number;
  idSolicitante: number;
  nomeSolicitante: string;

  // virtual
  idSimulacao: number;
  qtdPropostas: number;
}
